import { MS_IN_MINUTE } from '../../../utils/time-utils';

export const LIVES_REFILL_DURATION = MS_IN_MINUTE * 30;
export const LIVES_MAX = 5;
